import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, ArrowLeft, LogIn } from "lucide-react";
import { COMPANY } from "../lib/constants";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Accesso Admin · Impresa Edile Lici";
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Inserisci email e password.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("lici_admin_token", data.token);
      localStorage.setItem("lici_admin_email", data.email);
      toast.success("Accesso effettuato.");
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Credenziali non valide.";
      toast.error(typeof msg === "string" ? msg : "Errore.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen bg-[#FAFAFA] flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#4B5563] hover:text-[#0F5132] mb-8 transition-colors" data-testid="admin-back-home">
            <ArrowLeft className="h-4 w-4" /> Torna al sito
          </Link>

          <div className="bg-white border border-[#E5E7EB] rounded-2xl shadow-sm p-8 md:p-10">
            <div className="flex justify-center mb-6">
              <img src={COMPANY.logo} alt="Logo" className="h-20 w-20 object-contain" />
            </div>
            <h1 className="font-serif text-3xl text-[#0F5132] text-center">Accesso Admin</h1>
            <p className="text-sm text-[#4B5563] text-center mt-2">
              Area riservata per la gestione delle richieste preventivo.
            </p>

            <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
              <div>
                <label className="block text-xs uppercase tracking-widest text-[#4B5563] mb-2">
                  Email
                </label>
                <div className="relative">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-[#4B5563]" />
                  <input
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="admin-input-email"
                    className="w-full pl-11 pr-4 py-3 rounded-xl border border-[#E5E7EB] bg-[#FAFAFA] focus:outline-none focus:ring-2 focus:ring-[#0F5132] focus:border-[#0F5132]"
                    placeholder="ftvlici@gmail.com"
                  />
                </div>
              </div>
              <div>
                <label className="block text-xs uppercase tracking-widest text-[#4B5563] mb-2">
                  Password
                </label>
                <div className="relative">
                  <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-[#4B5563]" />
                  <input
                    type="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    data-testid="admin-input-password"
                    className="w-full pl-11 pr-4 py-3 rounded-xl border border-[#E5E7EB] bg-[#FAFAFA] focus:outline-none focus:ring-2 focus:ring-[#0F5132] focus:border-[#0F5132]"
                    placeholder="••••••••"
                  />
                </div>
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="admin-login-submit"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3.5 rounded-full bg-[#0F5132] text-white font-medium hover:bg-[#0A3622] transition disabled:opacity-60"
              >
                {loading ? "Accesso in corso…" : "Accedi"}
                <LogIn className="h-4 w-4" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
